module.exports = __webpack_public_path__ + "static/media/undraw_progressive_app_m9ms.93b50dae.svg";